module.exports = __webpack_public_path__ + "static/img/boyue_icon.923febf.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/shop_img_icon/boyue_icon.png
// module id = VKRP
// module chunks = 1